// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/comboboxSelector.scss';
import React from 'react';
import { Size } from '@front/sharedcomponents/Variables';
import { Style, StyleContext, StyleState } from '../../../Style';
import { SvgIcon } from '../../SvgIcon/SvgIcon';
import { SvgIconType } from '../../SvgIcon/SvgIconType';
export const ComboboxSelectorDecorator = React.forwardRef(({ children, onClick, isArrowVisible = true, size = Size.Medium, disabled = false, selected = false, containerClassName }, ref) => {
    const comboboxClassNames = [
        'combobox-selector',
        size,
        Style.Secondary,
        StyleContext.Combobox,
        disabled ? StyleState.Disabled : '',
        selected ? StyleState.Checked : ''
    ];
    const comboboxClassName = comboboxClassNames.filter(Boolean).join(' ');
    const comboboxContainerClassName = ['combobox-selector-container', containerClassName]
        .filter(Boolean)
        .join(' ');
    const renderArrow = () => {
        if (isArrowVisible) {
            return (React.createElement("div", { className: "combobox-selector-arrow" },
                React.createElement(SvgIcon, { icon: SvgIconType.ArrowDown })));
        }
        return null;
    };
    return (React.createElement("button", { ref: ref, className: comboboxClassName, disabled: disabled, onClick: onClick, "aria-expanded": selected, "aria-haspopup": "listbox" },
        React.createElement("div", { className: comboboxContainerClassName },
            children,
            renderArrow())));
});
